import { useState } from 'react'

import { useMutation } from '@percent/utility'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import type { UseReset2FAModalParams, UseReset2FAModalReturn, Reset2FAAccount } from './useReset2FAModal.types'

export function useReset2FAModal({ onSuccess }: UseReset2FAModalParams = {}): UseReset2FAModalReturn {
  const { accountService } = useServices()
  const [selectedAccount, setSelectedAccount] = useState<Reset2FAAccount | undefined>(undefined)

  const [, { mutateAsync }] = useMutation(accountService.reset2FA)

  const openModal = (account: Reset2FAAccount) => {
    setSelectedAccount(account)
  }

  const closeModal = () => {
    setSelectedAccount(undefined)
  }

  const reset2FA = async (accountId: string) => {
    await mutateAsync({ accountId })
    onSuccess?.()
  }

  return {
    selectedAccount,
    isModalOpen: !!selectedAccount,
    openModal,
    closeModal,
    reset2FA
  }
}
